import { createFileRoute } from '@tanstack/react-router'
import AssetGeneral from 'Asset/components/asset/Sections/AssetGeneral'

export const Route = createFileRoute('/assets/$id/general')({
    component: AssetGeneral,
})
